
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBrandCampaigns } from "api/myCampaignApi";

// Create async thunk for getting brand campaigns
export const getBrandCampaignsCall = createAsyncThunk(
    "filteredMyCampaigns/getfilteredMyCampaigns",
    async ({ token, data, page }, { rejectWithValue, dispatch }) => {
        try {
            const response = await getBrandCampaigns({ token, data, page });
            return response; // Return response if successful
        } catch (error) {
            // Handle errors here
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data); // Return the error from backend
            } else {
                return rejectWithValue(error.message || "An unknown error occurred");
            }
        }
    }
);